/**
 * Shared cutoff for one-time Desktop rollout logic. Anything created at or
 * after this instant has only ever known the Desktop presentation, so it
 * never needs the "we added Desktop" announcement (App.tsx) or the
 * last-active-window + Drive cleanup (services/onboarding/desktopWindowCleanup.ts).
 *
 * Mirrored in backend/scripts/migrate_desktop_window_cleanup.py as
 * DESKTOP_ROLLOUT_CUTOFF — keep both in lockstep.
 */
export const DESKTOP_ROLLOUT_CUTOFF = '2026-07-01T00:00:00.000Z';
